import { render } from "./Promociones.vue?vue&type=template&id=6b6959f4&scoped=true"
import script from "./Promociones.vue?vue&type=script&lang=js"
export * from "./Promociones.vue?vue&type=script&lang=js"

import "./Promociones.vue?vue&type=style&index=0&id=6b6959f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6959f4"]])

export default __exports__